import {
  Component,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  Content,
  LoadingController,
  ModalController,
  ToastController,
  App,
  AlertController,
} from 'ionic-angular';
import * as debug from 'debug';
import * as _ from 'lodash';
import { CrudApiProvider } from '../../../providers/crud-api/crud-api';
import { UserProvider } from '../../../providers/user/user';
import { ImageSelectorProvider } from '../../../providers/image-selector/image-selector';
import { PushNotificationsProvider } from '../../../providers/push-notifications/push-notifications';
import { Pro } from '@ionic/pro';
import { ToolsProvider } from '../../../providers/tools/tools';
import { MessagesProvider } from '../../../providers/messages/messages';
import { CameraSource } from '@capacitor/camera';
import * as $ from 'jquery';
import { App as AppPlugin, AppState } from '@capacitor/app';
import { UserVerificationProvider } from '../../../providers/user-verification/user-verification';
import { MediaSelectorProvider } from '../../../providers/image-selector/media-selector';
import { LiveChatProvider } from '../../../providers/live-chat/live-chat';
import { timeout } from 'rxjs/operator/timeout';
import { ConfigProvider } from '../../../providers/config/config';
import { Keyboard } from '@capacitor/keyboard';
import { Capacitor } from '@capacitor/core';
import { TaggingProvider } from '../../../providers/posts/tagging.provider';

declare let CmKit: any;

@Component({
  selector: 'lc-message-bar',
  templateUrl: 'message-bar.html',
})
export class LCMessageBarComponent {
  log = debug('app:LCMessageBarComponent');

  @ViewChild('polls') polls;
  @ViewChild('chatEngagementOptions') chatOptions;

  @Input() conversation: any = {};
  @Input() message: any = {};

  @Output() sendingMessage = new EventEmitter<boolean>();

  messages = [];
  newMessage = '';
  currentlyLoading: any = false;
  loading;
  firstScrolled = false;
  keyboardIsOpen = false;
  appStateListener;
  videoPoster;
  pollInformation: {};
  showTaggingAfterInit;

  @ViewChild(Content) content: Content;
  @ViewChild('mediaBar') mediaBar;
  @ViewChild('scrollCheckPoint')
  scrollCheckPoint;
  @ViewChild('autoFocusInput') autoFocusInput!: ElementRef;

  @ViewChild('messageBarInput') messageBarInput: ElementRef;

  onNotification;
  giphyPage = 1;
  mediaSelected: any[] = [];
  videoUrlToSend = '';
  userNavBlocked = false;
  disableSending = false;
  resettingTextArea = false;
  myAddedDate = '';
  timeInterval = null;
  muted = false;
  typingUsers = [];
  can_send = false;
  showKeyBoard = false;
  blueCircleStyle =
    'background-color: #2e5ff6; border-radius:50%; height:60px; width:60px; display:flex; justify-content:center; align-items:center;';
  engagementImgPath = 'assets/imgs/live-chat-icons/engagement-options/';
  photosIcon = `${this.engagementImgPath}photos.svg`;
  cameraIcon = `${this.engagementImgPath}camera.svg`;
  dailyRouteIcon = `${this.engagementImgPath}daily-route.svg`;
  gifIcon = `${this.engagementImgPath}gif.svg`;
  pollIcon = `${this.engagementImgPath}poll.svg`;
  imgPath = 'assets/imgs/live-chat-icons/ellipsis-menu-icons/';
  infoIcon = `<img src="${this.imgPath}info-circle.svg" />`;
  shareIcon = `<img src='${this.imgPath}share-square.svg' />`;
  bellIcon = `<img src='${this.imgPath}bell.svg' />`;
  silenceBellIcon = `<img src='${this.imgPath}silence-bell.svg' />`;
  inviteIcon = `<img src='${this.imgPath}invite-DM.svg' />`;
  cancelButton = `<div style='display:flex; width:100%; justify-content:center;'><button class="cm-Button cm-Button--2" cm-color="Primary / CDLLife Blue">
  Done
  </button></div>`;

  defaultAvatar = 'assets/imgs/default-avatar.png';
  inputType = '';

  liveChatEngagements = [
    { title: 'Photos', icon: this.photosIcon },
    { title: 'GIF', icon: this.gifIcon },
    // { title: 'Camera', icon: this.cameraIcon },
    { title: 'Poll', icon: this.pollIcon },
    // { title: 'Daily Route', icon: this.dailyRouteIcon },
  ];
  subs = [];
  replyId = null;

  taggingUser = true;

  taggedUsers = [];

  userSearch = '';

  searchId;

  filteredPeople = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public crudApi: CrudApiProvider,
    public user: UserProvider,
    public imageSelector: ImageSelectorProvider,
    public loadingCtrl: LoadingController,
    public push: PushNotificationsProvider,
    public tools: ToolsProvider,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    private mediaSelector: MediaSelectorProvider,
    public userVerification: UserVerificationProvider,
    public appCtrl: App,
    public liveChat: LiveChatProvider,
    public configs: ConfigProvider,
    public taggingProvider: TaggingProvider
  ) {}

  ngOnDestroy() {
    // this.onNotification && this.onNotification();
    // clearInterval(this.timeInterval);
    // this.appStateListener.remove();
  }

  async ngOnInit(): Promise<any> {
    this.showKeyBoard = this.navParams.get('showKeyBoard');

    this.subs.push(
      this.liveChat.on(`reply-to-reply`, async replyId => {
        this.log('reply-to-reply', replyId);
        this.replyId = replyId;
      })
    );

    this.tools.on('update-poll-data', data => {
      this.pollInformation = data;
      this.newMessage = data?.pollCaption;

      this.sendNewMessage();
    });
  }

  ngAfterViewInit() {
    if (this.messageBarInput) {
      if (this.showKeyBoard) {
        let input = this.messageBarInput.nativeElement;

        if (Capacitor.getPlatform() != 'web') {
          if (Capacitor.getPlatform() != 'ios') {
            Keyboard.show();
          }
          setTimeout(() => {
            const textarea = input.querySelector('textarea');
            textarea.focus();
          }, 1000);
        }
      }

      setTimeout(() => {
        this.showTaggingAfterInit = true;
      });
    }
  }

  navPopBack() {
    this.log('navPopBack');
    this.navCtrl.pop();
    // this.navCtrl.setRoot(HomePage, {}, { animate: true, direction: 'back' });
  }

  extractLink(data) {
    _.each(data, message => {
      if (message.postType === 'TEXT') {
        let content = message.message;
        const phoneNumbers = this.tools.phoneInString(content, true);
        const emails = this.tools.emailInString(content, true, true);
        const urls = _.difference(
          this.tools.urlInString(content, true, true),
          emails
        );

        const replaceAndSetClickListener = (type, value) => {
          const uniqId = _.uniqueId(`highlight-${type}`);
          message.message = _.replace(
            message.message,
            value,
            `<span class="${uniqId}"><u>${value}</u></span>`
          );

          setTimeout(() => {
            $(`.${uniqId}`).click(() => {
              this.openLinkActionsheet(
                type,
                _.trimEnd(_.trimStart(value, 'https://'), ',.')
              );
            });
          });
        };

        _.each(phoneNumbers, p => {
          replaceAndSetClickListener('phone', p);
        });

        _.each(urls, u => {
          replaceAndSetClickListener('url', u);
        });

        _.each(emails, e => {
          replaceAndSetClickListener('email', e);
        });
      }
    });
  }

  openLinkActionsheet(caseValue, linkValue) {
    switch (caseValue) {
      case 'url':
        CmKit.ActionSheet({
          props: {
            templates: {
              title: () => {
                return `
                   <div class="cm-ListItem cm-Padding--remove-horizontal cm-Margin--bottom" >
                      <div class="cm-ListItem-middle">
                        <div cm-font="Title / 20 Medium" style="text-align:center;">
                         ${linkValue}
                        </div>
                         <br/>
                      </div>
                    </div>
                 `;
              },
            },
            buttons: [
              {
                text: 'Open Link',
                handler: () => {
                  // seems unnessary but this keeps extract link working properly after opening link
                  setTimeout(() => {
                    window.open(`https://${linkValue}`, '_blank');
                  });
                },
              },
              {
                text: 'Copy',
                handler: () => {
                  this.tools.copyToClipboard(linkValue);
                },
              },
            ],
          },
        });
        break;
      case 'phone':
        CmKit.ActionSheet({
          props: {
            templates: {
              title: () => {
                return `
                   <div class="cm-ListItem cm-Padding--remove-horizontal cm-Margin--bottom" >
                      <div class="cm-ListItem-middle">
                        <div cm-font="Title / 20 Medium" style="text-align:center;">
                         ${linkValue}
                        </div>
                         <br/>
                      </div>
                    </div>
                 `;
              },
            },
            buttons: [
              {
                text: `Call +${linkValue}`,
                handler: () => {
                  this.tools.callPhone(linkValue);
                },
              },
              {
                text: 'Copy',
                handler: () => {
                  this.tools.copyToClipboard(linkValue);
                },
              },
            ],
          },
        });
        break;
      case 'email':
        CmKit.ActionSheet({
          props: {
            templates: {
              title: () => {
                return `
                   <div class="cm-ListItem cm-Padding--remove-horizontal cm-Margin--bottom" >
                      <div class="cm-ListItem-middle">
                        <div cm-font="Title / 20 Medium" style="text-align:center;">
                         ${linkValue}
                        </div>
                         <br/>
                      </div>
                    </div>
                 `;
              },
            },
            buttons: [
              {
                text: 'Send Email',
                handler: () => {
                  window.open(`mailto:${linkValue}`, '_system');
                },
              },
              {
                text: 'Copy',
                handler: () => {
                  this.tools.copyToClipboard(linkValue);
                },
              },
            ],
          },
        });
        break;
    }
  }

  ionViewDidLoad() {
    this.log('ionViewDidLoad ChatPage');
    this.resizeContent();
  }

  private toastError() {
    this.disableSending = true;
    let toast = this.toastCtrl.create({
      message: 'Error: Conversation not found',
      duration: 3000,
    });
    this.dismissLoading();
    setTimeout(() => {
      toast.present();
    }, 500);
  }

  private presentLoading() {
    if (!this.currentlyLoading) {
      this.currentlyLoading = true;
      this.loading = this.loadingCtrl.create({
        content: 'Please wait...',
      });
      this.loading.present();
    }
  }

  private dismissLoading() {
    this.loading && this.loading.dismiss();
    this.loading = null;
    this.currentlyLoading = false;
  }

  scrollToBottom(duration = 300, delay = 200) {
    try {
      this.log('scroll to bottom');
      setTimeout(() => {
        this.firstScrolled = true;
        if (this.content) {
          this.content.scrollToBottom(duration);
        }
      }, delay);
    } catch (e) {}
  }

  canSendMessage(allow) {
    this.can_send = allow;
  }

  checkCanSend = _.debounce(() => {
    const allow = !!(_.size(this.mediaSelected) || _.size(this.newMessage));
    this.can_send = allow;
    console.log('checkCanSend', allow);
    return allow;
  }, 50);

  async sendNewMessage() {
    this.log('sendNewMessage');
    if (await this.userVerification.isRiskyAndNotVerified()) {
      return;
    }

    if (this.disableSending) {
      this.toastError();
      return;
    }

    this.scrollToBottom(300, 200);

    if (this.checkCanSend()) {
      this.log('sendNewMessage | media urls', this.mediaSelected);
      const imageUploads = [];
      _.each(this.mediaSelected, url => {
        imageUploads.push(
          new Promise(async (rs, rj) => {
            const metadata = await this.getMetadata(url);
            rs({ url, metadata });
          })
        );
      });
      const media = await Promise.all(imageUploads);
      this.log('sendNewMessage | media with meta', media);
      await this.sendMessage(media);
      this.mediaSelected = [];
      this.checkCanSend();
      this.resizeContent();
    } else {
      this.sendMessage();
    }

    this.sendingMessage.emit(true);

    // Additional logic after sending the message if needed
    setTimeout(() => {
      this.sendingMessage.emit(false);
      // Set to false after the message is sent
    }, 1000); // Adjust the timeout as needed
  }

  private async sendMessage(media = []) {
    const isReply = !!_.get(this.message, '_id');
    if (!this.currentlyLoading) {
      // this.presentLoading();
      //PREPING TO SEND MESSAGE TO DB

      let messageObj = {
        conversationId: this.conversation._id,
        message: this.taggingProvider.replaceSpanMentions(this.newMessage),
        ...(this.replyId && { replyId: this.replyId }),
        media,
        directMessage: this.conversation.directMessage,
        removedUserIds: this.conversation.removedUserIds,
        pollInformation: this.pollInformation,
        taggedUserIds: _.map(this.taggingProvider.taggedUsers, '_id'),
        taggedUsers: this.taggingProvider.taggedUsers,
      };

      if (isReply) {
        _.set(messageObj, 'messageId', this.message._id);
      }

      this.keyboardIsOpen = false;
      this.newMessage = '';
      this.resizeContent();
      // this.scrollToBottom(300, 200);
      this.resettingTextArea = true;
      setTimeout(() => {
        this.resettingTextArea = false;
      });

      this.tools.logAnalyticsEvent('trackCustom', 'direct-message');

      // this.liveChat.sendSupportQuestion();
      this.liveChat
        .sendMessage(messageObj, _.get(this.conversation, 'socketId'))
        .then(newMessage => {
          this.replyId = null;

          // tagging component listeners die because cmkit input rerenders
          this.showTaggingAfterInit = false;
          setTimeout(() => {
            this.showTaggingAfterInit = true;
          });
          // this.extractLink(this.conversation.messages);
          // this.scrollToBottom(300, 200);
        })
        .catch(e => {
          // this.log('error sending message');
          this.tools.logAnalyticsEvent(
            'trackCustom',
            'text-message-send-error'
          );
        });
    }
    this.pollInformation = null;
  }

  resizeContent() {
    // unfortunately, it's not reliable
    setTimeout(() => this.resize(), 10);
    setTimeout(() => this.resize(), 50);
    setTimeout(() => this.resize(), 250);
  }

  resize() {
    try {
      this.content.resize();
    } catch (e) {}
  }

  removeImage(url: string) {
    this.mediaSelected = _.pull(this.mediaSelected, url);
    this.checkCanSend();
  }

  async overLimitToast() {
    const configLimit = this.configs.get('lc-media-upload-limit') || 6;
    if (_.size(this.mediaSelected) >= configLimit) {
      this.toastCtrl
        .create({
          message: `Only ${configLimit} uploads allowed`,
          duration: 2000,
        })
        .present();
      return Promise.resolve(false);
    } else {
      return Promise.resolve(true);
    }
  }

  async presentAddVideoActionSheet() {
    if (!(await this.overLimitToast())) return;

    event.stopImmediatePropagation();

    const video = await this.mediaSelector.getMediaByType('video');

    this.log('video', video);

    this.mediaSelected.push({
      url: _.get(video, 'url'),
      metadata: {},
      poster: _.get(video, 'poster'),
    });

    this.checkCanSend();
    this.scrollToMediaEnd();

    this.log('videoUrlToSend', this.videoUrlToSend, this.videoPoster, video);
    this.dismissLoading();
    this.tools.logAnalyticsEvent(
      'trackCustom',
      `lc-view-messageBar-presentAddVideoActionSheet`
    );
  }

  async presentAddPhotoActionSheet() {
    if (!(await this.overLimitToast())) return;

    event.stopImmediatePropagation();

    const files = await this.mediaSelector.getMediaByType('photo');
    this.log('files', files);

    const file = _.head(files);
    this.mediaSelected.push(_.get(file, 'url'));
    this.checkCanSend();
    this.scrollToMediaEnd();
    this.dismissLoading();
    this.tools.logAnalyticsEvent(
      'trackCustom',
      `lc-view-messageBar-presentAddPhotoActionSheet`
    );
  }

  scrollToMediaEnd() {
    setTimeout(() => {
      const el = this.mediaBar.nativeElement;
      let totalWidth = 0;
      _.each(el.childNodes, node => {
        if (node.className === 'cm-MessageBar-image') {
          totalWidth += node.clientWidth;
        }
      });
      el.scrollTo(totalWidth + 100, 0);
    }, 100);
  }

  private getMetadata(url): Promise<{ url: string; metadata: any }> {
    return new Promise<{ url: string; metadata: any }>((resolve, reject) => {
      this.imageSelector
        .getMetadata(url)
        .then(metadata => {
          this.log('got metadata', url, metadata);
          return resolve({ url, metadata });
        })
        .catch(e => {
          this.log('we have an error getting metadata', e);
          reject();
        });
    });
  }

  navToUsersProfile(friend) {
    if (this.userNavBlocked) {
      return;
    }
    this.navCtrl.push('UserProfilePage', {
      user: friend,
      user_id: friend,
    });
  }

  async getGiphy() {
    this.tools.logAnalyticsEvent('trackCustom', `lc-view-messageBar-getGiphy`);
    if (!(await this.overLimitToast())) return;
    this.log('getting gif');

    const modal = this.modalCtrl.create('GiphyPage');
    modal.onDidDismiss(url => {
      this.log('got Giphy', url);
      if (url) {
        this.tools.logAnalyticsEvent(
          'trackCustom',
          `lc-view-messageBar-selectedGiphy`
        );
        this.mediaSelected.push(url);
        this.checkCanSend();
      }
      this.scrollToMediaEnd();
    });
    modal.present();
  }

  openInviteFriendsPage(conversation) {
    this.navCtrl.push('ChatInviteFriendsPage', {
      conversation: this.conversation,
      conversation_id: _.get(this.conversation, 'data._id'),
    });
  }

  async showChatEngagementOptions(type: string) {
    this.chatOptions.hide();
    switch (type) {
      case 'Photos':
        this.presentAddPhotoActionSheet();
        break;
      case 'Camera':
        this.presentAddVideoActionSheet();
        break;
      case 'Poll':
        this.navToPolls();
        break;
      case 'Daily Route':
        // TODO
        console.log('Sharing daily route...');
        break;
      case 'GIF':
        this.getGiphy();
        break;
      default:
        console.log('Invalid option selected');
    }
  }

  navToPolls() {
    this.log('navToPolls', this.message);
    this.navCtrl.push('PollsPage', {
      message: this.newMessage,
    });
  }

  showChatOptions() {
    this.chatOptions.show();
  }

  onChange(e) {
    this.newMessage = e.detail.value;
    this.resizeContent();
    this.emitTyping();
    this.checkCanSend();
  }

  getFilteredPeople() {
    this.filteredPeople = this.taggingProvider.searchResults.people.filter(
      person =>
        !this.taggedUsers.some(taggedPerson => taggedPerson._id === person._id)
    );
  }

  emitTyping = _.debounce(async () => {
    this.log('emitTyping');
    this.liveChat.emitTyping(
      _.get(this.conversation, 'socketId'),
      _.get(this.message, '_id')
    );
  }, 500);

  emitTypingStopped = _.debounce(() => {
    this.log('emitTypingStopped');
    this.liveChat.emitTypingStopped(
      _.get(this.conversation, 'socketId'),
      _.get(this.message, '_id')
    );
  }, 500);

  closeTaggingList() {
    this.taggingUser = false;
    this.userSearch = '';
    this.newMessage = this.newMessage + ' ';
  }
}



// WEBPACK FOOTER //
// ./src/components/_live-chat/message-bar/message-bar.ts